<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
            {{ $t('change_password') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
          <v-form class="px-2">
            <ValidationProvider v-slot="{ errors, valid }" name="current_password" rules="required">
              <v-text-field v-model="form.old_password" :type="visibility ? 'text' : 'password'" label="Current Password" color="primary" :error-messages="errors" :append-icon="visibility ? 'mdi-eye' : 'mdi-eye-off'" autocomplete="on" @click:append="visibility = !visibility" />
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors, valid }" name="password" rules="required|min:8">
              <v-text-field v-model="form.new_password" :type="new_visibility ? 'text' : 'password'" label="New Password" color="primary" :error-messages="errors" :append-icon="new_visibility ? 'mdi-eye' : 'mdi-eye-off'" autocomplete="on" @click:append="new_visibility = !new_visibility" />
            </ValidationProvider>
            <v-btn color="primary" x-large block class="text-none" @click="changePassword">
              {{ $t('save') }}
            </v-btn>
          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  changePassword as changePasswordCustomer
} from '@/api/customer'
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      visibility: false,
      new_visibility: false,
      form: {
        old_password: '',
        new_password: ''
      }
    }
  },
  methods: {
    goBack() {
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'home' }).catch(() => {})
      }
    },
    async changePassword() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        try {
          await changePasswordCustomer(this.form)
          this.$store.state.loading_axios = false
          this.$store.dispatch('fetchToken')
          this.$router.push({ name: 'login', query: { redirect: this.$route.query.redirect }}).catch(() => {})
        } catch (e) {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    }
  }
}
</script>
